import { ControlledCustomSwitch } from 'components/TasksV2/UI/ControlledCustomSwitch'
import useLocaleText from 'components/useLocaleText'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { SettingItem } from './SettingItem'

interface CreateActionPopSwitchProps {
  number: number
}

export const CreateActionPopSwitch: React.FC<CreateActionPopSwitchProps> = ({ number }) => {
  const { control } = useFormContext()

  const t_sendActionPop = useLocaleText('send_action_pop') || 'Send action pop'

  return (
    <SettingItem
      number={number}
      title={t_sendActionPop}
      control={
        <Controller
          as={ControlledCustomSwitch}
          name="send_action_pop"
          control={control}
          valueName="isChecked"
          size="lg"
          onChange={([event]) => {
            return event.target.checked
          }}
        />
      }
    />
  )
}
